import * as React from 'react'

import { SimpleTitleButtonHero } from 'sdk/sections'
import { HeroTitle } from 'components/hero-title/HeroTitle'

import lightningIcon from 'shared/assets/icons/lightning-gradient.svg'
import homeHeroBg from '../../assets/home-hero-bg.jpg'

export const Hero: React.FC = () => {
  const title = (
    <HeroTitle 
      pillText="Blazing fast" 
      pillIcon={lightningIcon} 
      titleText="Accelerated Audio Computing"
    />
  )

  return (
    <SimpleTitleButtonHero
      title={title}
      description="Using the power of GPUs to enhance audio  in real-time"
      imageLink={homeHeroBg}
      alignment="center"
    />
  )
}